import { useQuery } from '@tanstack/react-query';
import { FeaturesApi } from '../../../apis/FeaturesApi/FeaturesApi';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { IFeature } from '../Feature';

export function useAllFeatures() {
    return useQuery<IFeature[]>({
        queryKey: [QueryKeys.allFeatures],
        queryFn: () => FeaturesApi.getAllFeatures(),
    });
}
